import { init, lights, render, makeEnvMap, background } from './general.js'
import { terrain, monolith, more, fog, alienTerrain } from './Objects.js'
import { initTextures } from './textures.js'

export async function run() {
    await initTextures()
    init()
    background()
    lights()
    terrain()
    // makeEnvMap()
    monolith()
    fog()
    more()
    alienTerrain()
    render()
}